<template>
    <div>
        <b-card no-body v-if="mostrarMenu">
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONVÊNIOS - Relatórios</span>
                </h4>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONV-REL-01')"
                                :href="`#/convenios/relatorios/relatoriogeral`">
                                <strong>Relatório Geral</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONV-REL-03')"
                                :href="`#/convenios/relatorios/porcompetencia`">
                                <strong>Relatório Por Competência</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONV-REL-04')"
                                :href="`#/convenios/relatorios/porcapa`">
                                <strong>Relatório Por Capa da Prestação</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONV-REL-02')"
                                :href="`#/convenios/relatorios/despesas`">
                                <strong>Relatório Despesas Previstas x Realizadas</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONV-REL-02')"
                                :href="`#/convenios/relatorios/pendencias`">
                                <strong>Relatório de Pendências</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    computed: {
        mostrarMenu() {
            return this.$route.name == 'Convenios_Relatorios'
        }
    },
}
</script>
